import { toggle } from "@saleor/utils/lists";
import isEqual from "lodash-es/isEqual";
import { useState } from "react";

import useStateFromProps from "./useStateFromProps";

export interface ChangeEvent<TData = any> {
  target: {
    name: string;
    value: TData;
    // index?: number;
  };
}
export type SubmitPromise = Promise<any[]>;

export type FormChange = (event: ChangeEvent, cb?: () => void) => void;

export interface UseFormResult<T> {
  change: FormChange;
  data: T;
  hasChanged: boolean;
  reset: () => void;
  set: (data: T) => void;
  submit: () => void;
  triggerChange: () => void;
  toggleValue: FormChange;
  setNameValue: (name, value) => void; // 自定义更新name的value
}

type FormData = Record<string, any | any[]>;

function merge<T extends FormData>(prevData: T, prevState: T, data: T): T {
  return Object.keys(prevState).reduce(
    (acc, key) => {
      if (!isEqual(data[key], prevData[key])) {
        acc[key as keyof T] = data[key];
      }

      return acc;
    },
    { ...prevState }
  );
}

function handleRefresh<T extends FormData>(
  data: T,
  newData: T,
  setChanged: (status: boolean) => void
) {
  if (isEqual(data, newData)) {
    setChanged(false);
  }
}

function useForm<T extends FormData>(
  initial: T,
  onSubmit?: (data: T) => SubmitPromise | void
): UseFormResult<T> {
  const [hasChanged, setChanged] = useState(false);
  const [data, setData] = useStateFromProps(initial, {
    mergeFunc: merge,
    onRefresh: newData => {
      handleRefresh(data, newData, setChanged);
    }
  });

  function toggleValue(event: ChangeEvent, cb?: () => void) {
    const { name, value } = event.target;
    const field = data[name as keyof T];

    if (Array.isArray(field)) {
      if (!hasChanged) {
        setChanged(true);
      }
      setData({
        ...data,
        [name]: toggle(value, field, isEqual)
      });
    }

    if (typeof cb === "function") {
      cb();
    }
  }

  function getValueByKey(jsonData, path) {
    const keyArr = path.split(".");
    let value = jsonData;

    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < keyArr.length; i++) {
      const key = isNaN(Number(keyArr[i])) ? keyArr[i] : Number(keyArr[i]);
      const item = value[key];
      if (item !== undefined) {
        value = item;
      } else {
        return undefined;
      }
    }
    return value;
  }
  function changeTreeDate(date, key, val) {
    const keyArr = key.split(".");

    for (let i = 0; i < keyArr.length; i++) {
      const key = isNaN(Number(keyArr[i])) ? keyArr[i] : Number(keyArr[i]);
      const item = date[key];
      const isObJ = typeof item === "object";
      if (item !== undefined) {
        if (i === keyArr.length - 1) {
          return (date[key] = val);
        }
        if (isObJ) {
          return changeTreeDate(item, keyArr.slice(i + 1).join("."), val);
        }
      }
      return false;
    }
  }
  // function changeProductsData(newData, name, value, index) {
  //   if (
  //     name === "usageLimit" ||
  //     name === "discountPrice" ||
  //     name === "sortOrder"
  //   ) {
  //     // if (name === "sortOrder") {
  //     return (newData.products[index][name] = value);
  //     // } else {
  //     //   newData.products[index][name] = Number(value);
  //     // }
  //     // return newData;
  //   } else {
  //     return newData;
  //   }
  // }

  function change(event: ChangeEvent) {
    // const { name, value, index } = event.target;
    const { name, value } = event.target;
    const oldVal: any = getValueByKey(data, name);
    const newData = { ...data };
    // if (
    //   name === "usageLimit" ||
    //   name === "discountPrice" ||
    //   name === "sortOrder"
    // ) {
    //   changeProductsData(newData, name, value, index);
    // }else{
    changeTreeDate(newData, name, value);
    // }

    if (!(name in data) && !oldVal === undefined) {
      console.error(`Unknown form field: ${name}`);
      return;
    } else {
      if (oldVal !== value) {
        setChanged(true);
      }
      setData(newData);
    }
  }
  // 不需要触发onchange事件改变值
  function setNameValue(name, value) {
    const oldVal: any = getValueByKey(data, name);
    const newData = { ...data };

    changeTreeDate(newData, name, value);

    if (!(name in data) && !oldVal === undefined) {
      console.error(`Unknown form field: ${name}`);
      return;
    } else {
      if (oldVal !== value) {
        setChanged(true);
      }
      setData(newData);
    }
  }

  function reset() {
    setData(initial);
  }

  function set(newData: Partial<T>) {
    setData(data => ({
      ...data,
      ...newData
    }));
  }

  async function submit() {
    if (typeof onSubmit === "function") {
      const result = onSubmit(data);
      if (result) {
        const errors = await result;
        if (errors?.length === 0) {
          setChanged(false);
        }
      }
    }
  }

  function triggerChange() {
    setChanged(true);
  }

  return {
    change,
    data,
    hasChanged,
    reset,
    set,
    submit,
    toggleValue,
    triggerChange,
    setNameValue
  };
}

export default useForm;
